"use strict";

exports.__esModule = true;
exports.FORUM_STRUCTURE_FEED = exports.FORUM_STRUCTURE_REGULAR = void 0;
var FORUM_STRUCTURE_REGULAR = 0;
exports.FORUM_STRUCTURE_REGULAR = FORUM_STRUCTURE_REGULAR;
var FORUM_STRUCTURE_FEED = 1;
exports.FORUM_STRUCTURE_FEED = FORUM_STRUCTURE_FEED;